import { SplitFactory } from '@splitsoftware/splitio'

import CONFIG from '../config'
import { parsedAuth } from './AuthService'

export const splitFactory = SplitFactory({
  core: {
    authorizationKey: CONFIG.splitIO.apiKey,
    key: 'anonymous',
  },
  // Use below to override dev mode(localhost)
  features: {
    access_control: 'on',
    water_control: 'on',
  },
})

// Store and reuse split clients per id
const splitClients = {}
export function splitClient(id) {
  splitClients[id] = splitClients[id] || splitFactory.client(id)
  return splitClients[id]
}

export function splitTreatment(id, name, attributes) {
  return splitClient(id).getTreatment(name, attributes)
}

export function splitCheck(name, value, auth, attributes = {}) {
  const parsed = parsedAuth(auth)
  return splitTreatment(parsed.sub, name, { ...attributes, ...parsed }) === value
}

export function splitOn(name, auth, attributes = {}) {
  return splitCheck(name, 'on', auth, attributes)
}
